import React from 'react';

const LoadingSpinnerPage = () => (
  <div className="Page" >
    <div className="spinner" />
  </div>
);

export default LoadingSpinnerPage;
